function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField } from 'seagull';
import { useUpdateRelationship } from "../../hooks/useUpdateRelationship";
import { agreementChangeModel } from "../../models";
import { agreementNameValidation, connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./RenameAgreementModal.module.scss";
import { useStoreActions } from "../../contexts";
export default function RenameAgreementModal(props) {
  const {
    relationship,
    onSuccess,
    dismissModal
  } = props;
  const {
    control,
    formState,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      title: relationship.title
    }
  });
  const {
    logBI
  } = useStoreActions();
  const updateRelationship = useUpdateRelationship();
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Rename agreement",
    onCloseButtonClick: dismissModal,
    primaryButtonTestid: "rename-agr",
    primaryButtonDisabled: !formState.isDirty,
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: handleSubmit(async _ref => {
      let {
        title
      } = _ref;
      updateRelationship(_objectSpread(_objectSpread({}, relationship), {}, {
        changes: [agreementChangeModel.makeTitleChange(title)],
        onSuccess: function (_onSuccess) {
          function onSuccess() {
            return _onSuccess.apply(this, arguments);
          }

          onSuccess.toString = function () {
            return _onSuccess.toString();
          };

          return onSuccess;
        }(() => {
          logBI(14050);
          onSuccess(title);
          dismissModal();
        })
      }));
    }),
    onSecondaryButtonClick: dismissModal,
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "title",
      rules: agreementNameValidation,
      render: p => /*#__PURE__*/React.createElement(TextField, _extends({
        autoFocus: true,
        testid: "agr-name",
        label: "Agreement name"
      }, connectControllerToTextField(p)))
    }))
  });
}